<template>
    <div class="edit-multi-record">
        <a-steps :current="currentStep">
            <a-step title="Select Field" />
            <a-step title="Update Value" />
        </a-steps>

        <div class="step-content">
            <div v-if="currentStep === 0">
                <p>{{ $t("tables.pleaseUpdateSelected") }}</p>
                <div class="field-list">
                    <div
                        v-for="field in fields"
                        :key="field._id"
                        class="field-item"
                        :class="{ selected: selectedField === field }"
                        @click="selectedField = field"
                    >
                        <div class="field-icon">
                            <i class="material-icons">{{ getIcon(field) }}</i>
                        </div>
                        <div class="field-name">{{ field.name }}</div>
                    </div>
                </div>
            </div>

            <div v-if="currentStep === 1">
                <p>{{ $t("tables.pleaseSelectedNewValue") }}</p>

                <!-- Text Alanları -->
                <a-input
                    v-if="['text', 'long-text', 'email', 'url', 'phone'].includes(selectedField.fieldType)"
                    v-model="fieldValue"
                />

                <!-- Sayısal Alanlar -->
                <a-input-number
                    v-else-if="['number', 'currency'].includes(selectedField.fieldType)"
                    v-model="fieldValue"
                />

                <!-- Tarih Alanları -->
                <a-date-picker v-else-if="selectedField.fieldType === 'datetime'" v-model="fieldValue" />

                <!-- Seçim Alanları -->
                <CustomPicker
                    v-else-if="selectedField.fieldType === 'dropdown'"
                    v-model="fieldValue"
                    :items="selectedField.options.dropdown.options"
                    :multiple="selectedField.options.dropdown.multiple"
                    idKey="value"
                    labelKey="value"
                />

                <!-- Checkbox Alanları -->
                <a-switch v-else-if="selectedField.fieldType === 'checkbox'" v-model="fieldValue" />

                <!-- Varsayılan -->
                <a-input v-else v-model="fieldValue" />
            </div>
        </div>

        <div class="action-buttons">
            <a-button @click="handleCancel">Cancel</a-button>
            <a-button type="primary" @click="handleNext" :disabled="currentStep === 0 && !selectedField">
                {{ currentStep === 0 ? "Next" : "Save" }}
            </a-button>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { TABLE_API } from "../../../../../api/table";
import CustomPicker from "../../../../../components/pickers/CustomPicker.vue";

export default Vue.extend({
    name: "EditMultiRecord",
    components: {
        CustomPicker,
    },
    props: {
        table: Object,
        fields: Array,
        selectedRecords: Array,
    },
    data() {
        return {
            currentStep: 0,
            selectedField: null,
            fieldValue: null,
        };
    },
    methods: {
        async handleNext() {
            if (this.currentStep === 0) {
                this.currentStep = 1;
            } else {
                try {
                    await TABLE_API.updateMultiRecord(
                        this.table._id,
                        this.selectedField._id,
                        this.selectedRecords,
                        this.fieldValue
                    );
                    this.$emit("records-updated");
                    this.handleCancel();
                } catch (error) {
                    console.error("Error updating records:", error);
                    this.$message.error("Error updating records.");
                }
            }
        },
        handleCancel() {
            this.$emit("cancel");
        },
        getIcon(field) {
            switch (field.fieldType) {
                case "text":
                case "long-text":
                    return "text_fields";
                case "number":
                    return "looks_one";
                // ... diğer alan türleri için ikonlar
                default:
                    return "help_outline";
            }
        },
    },
});
</script>

<style scoped lang="scss">
.edit-multi-record {
    .step-content {
        margin: 24px 0;
        min-height: 200px;
        padding: 24px;
        background-color: #fafafa;
    }

    .action-buttons {
        text-align: right;

        button {
            margin-left: 8px;
        }
    }

    .field-list {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 16px;
    }

    .field-item {
        display: flex;
        align-items: center;
        padding: 16px;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        cursor: pointer;

        &.selected {
            border-color: #1890ff;
            background-color: #e6f7ff;
        }

        .field-icon {
            margin-right: 8px;

            i {
                font-size: 20px;
            }
        }

        .field-name {
            font-weight: 500;
        }
    }
}
</style>
